import asyncActionType from "../../Utils/reduxActions";

// Incident Action Types
const INCIDENT_ACTIONS = {
  // List
  INCIDENT_LIST: asyncActionType("[VERTEX360]INCIDENT_LIST"),
  INCIDENT_LIST_CALL: "[VERTEX360]INCIDENT_LIST_CALL",

  // Dashboard
  INCIDENT_DASHBOARD: asyncActionType("[VERTEX360]INCIDENT_DASHBOARD"),
  INCIDENT_DASHBOARD_CALL: "[VERTEX360]INCIDENT_DASHBOARD_CALL",

  // Detail
  INCIDENT_DETAIL: asyncActionType("[VERTEX360]INCIDENT_DETAIL"),
  INCIDENT_DETAIL_CALL: "[VERTEX360]INCIDENT_DETAIL_CALL",

  // Create
  INCIDENT_CREATE: asyncActionType("[VERTEX360]INCIDENT_CREATE"),
  INCIDENT_CREATE_CALL: "[VERTEX360]INCIDENT_CREATE_CALL",

  // Update
  INCIDENT_UPDATE: asyncActionType("[VERTEX360]INCIDENT_UPDATE"),
  INCIDENT_UPDATE_CALL: "[VERTEX360]INCIDENT_UPDATE_CALL",

  // Investigate
  INCIDENT_INVESTIGATE: asyncActionType("[VERTEX360]INCIDENT_INVESTIGATE"),
  INCIDENT_INVESTIGATE_CALL: "[VERTEX360]INCIDENT_INVESTIGATE_CALL",

  // Close
  INCIDENT_CLOSE: asyncActionType("[VERTEX360]INCIDENT_CLOSE"),
  INCIDENT_CLOSE_CALL: "[VERTEX360]INCIDENT_CLOSE_CALL",

  // Close Draft
  INCIDENT_CLOSE_DRAFT: asyncActionType("[VERTEX360]INCIDENT_CLOSE_DRAFT"),
  INCIDENT_CLOSE_DRAFT_CALL: "[VERTEX360]INCIDENT_CLOSE_DRAFT_CALL",

  // Delete
  INCIDENT_DELETE: asyncActionType("[VERTEX360]INCIDENT_DELETE"),
  INCIDENT_DELETE_CALL: "[VERTEX360]INCIDENT_DELETE_CALL",

  // Export
  INCIDENT_EXPORT: asyncActionType("[VERTEX360]INCIDENT_EXPORT"),
  INCIDENT_EXPORT_CALL: "[VERTEX360]INCIDENT_EXPORT_CALL",

  // Assigned Participants
  GET_ASSIGNED_PARTICIPANTS: asyncActionType("[VERTEX360]GET_ASSIGNED_PARTICIPANTS"),
  GET_ASSIGNED_PARTICIPANTS_REQUEST: "[VERTEX360]GET_ASSIGNED_PARTICIPANTS_REQUEST",

  // Bulk PDF Generate
  INCIDENT_BULK_PDF_GENERATE: asyncActionType("[VERTEX360]INCIDENT_BULK_PDF_GENERATE"),
  INCIDENT_BULK_PDF_GENERATE_CALL: "[VERTEX360]INCIDENT_BULK_PDF_GENERATE_CALL",

  // Reset
  INCIDENT_RESET_DETAIL: "[VERTEX360]INCIDENT_RESET_DETAIL",
  INCIDENT_RESET_CREATE: "[VERTEX360]INCIDENT_RESET_CREATE",
  INCIDENT_RESET_DELETE: "[VERTEX360]INCIDENT_RESET_DELETE",
  INCIDENT_RESET_INVESTIGATE: "[VERTEX360]INCIDENT_RESET_INVESTIGATE",
  INCIDENT_RESET_CLOSE: "[VERTEX360]INCIDENT_RESET_CLOSE",
  INCIDENT_RESET_CLOSE_DRAFT: "[VERTEX360]INCIDENT_RESET_CLOSE_DRAFT",
  INCIDENT_RESET_BULK_PDF_GENERATE: "[VERTEX360]INCIDENT_RESET_BULK_PDF_GENERATE",
};

export default INCIDENT_ACTIONS;
